import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  style: {"margin-top":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "las la-reply" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isDisplay,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDisplay) = $event)),
    title: _ctx.titleDisplay,
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      (_ctx.progress === _ctx.PRODUCT_SELECTING_PROGRESS.SELECTING_CATEGORY)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _ctx.allCategoryProducts,
            border: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "Tên danh mục",
                property: "ten_danh_muc"
              }),
              _createVNode(_component_el_table_column, {
                label: "Mô tả",
                property: "mo_ta"
              }),
              _createVNode(_component_el_table_column, null, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.categorySelectedHandler(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Chọn")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.progress === _ctx.PRODUCT_SELECTING_PROGRESS.SELECTING_PRODUCT)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: _ctx.selectingProducts,
            "empty-text": "Không có toa xe nào trong danh mục này"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "Tên toa xe",
                property: "ten_san_pham"
              }),
              _createVNode(_component_el_table_column, {
                label: "Số hiệu",
                property: "so_hieu"
              }),
              _createVNode(_component_el_table_column, {
                label: "Mô tả",
                property: "mo_ta"
              }),
              _createVNode(_component_el_table_column, {
                label: "Ghi chú",
                property: "ghi_chu"
              }),
              _createVNode(_component_el_table_column, null, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.productSelectedHandler(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Chọn")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.progress === _ctx.PRODUCT_SELECTING_PROGRESS.SELECTING_PRODUCT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_button, { onClick: _ctx.backToCategoryListButtonClickedHandler }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}